/*
  Recalage de la galerie apres fermeture du zoom.

  A l'ouverture de la modale, le theme pose overflow:hidden sur le body :
  la barre de defilement disparait et la fenetre gagne sa largeur (15px sur
  Chrome/Windows). Le rail horizontal de la galerie recalcule sa position
  dans cette largeur, puis la conserve a la fermeture. Resultat : l'image
  active se retrouvait decalee et laissait voir un liseré de sa voisine.

  On remet le rail sur l'image active. Deux passages, car le theme fait son
  propre recalcul juste apres la fermeture. Pas de requestAnimationFrame :
  il ne se declenche pas dans un onglet en arriere-plan.
*/
(function () {
  function recaler() {
    document.querySelectorAll('.product__media-list').forEach(function (liste) {
      var actif = liste.querySelector('.product__media-item.is-active');
      if (!actif) return;
      var cible = actif.offsetLeft - liste.offsetLeft;
      if (Math.abs(liste.scrollLeft - cible) > 1) liste.scrollLeft = cible;
    });
  }

  function surveiller(modale) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open' && !modale.hasAttribute('open')) {
          setTimeout(recaler, 60);
          setTimeout(recaler, 350);
        }
      });
    }).observe(modale, { attributes: true, attributeFilter: ['open'] });
  }

  function demarrer() {
    document.querySelectorAll('product-modal').forEach(surveiller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
